import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

export default function OrderDetailsMetadata(): JSX.Element {
  const { t } = useTranslation(['ordersPage']);

  return (
    <Helmet>
      <title>
        {t('META_TITLE_TEMPLATE', {
          title: t('ORDER_DETAILS_META_TITLE'),
          ns: 'translation',
        })}
      </title>
    </Helmet>
  );
}
